import { ConfigScreenColors } from 'constants/redesignedFlow';

export const DEFAULT_HEADER_SETTINGS = {
    isBackgroundOn: false,
    logoColor: ConfigScreenColors.BLACK,
};
